import { AxiosError } from "axios";
import { getOrgStructureNRAgent } from "./newRelicAgent";

const getAdditionalErrorData = (error: unknown) => {
  if (error instanceof AxiosError) {
    return {
      status:
        error.code === AxiosError.ERR_CANCELED
          ? AxiosError.ERR_CANCELED
          : `HTTP ${error.status}`,
      url: `${error?.config?.baseURL}${error?.config?.url}`,
      method: error?.config?.method ?? "Unknown request method",
    };
  }
  return {};
};

const reportErrorToNewRelic = (
  error: unknown,
  message = "no context provided"
) => {
  const agent = getOrgStructureNRAgent();
  if (!agent) return;

  agent.noticeError(
    typeof error === "string" ? error : (error as Error).message,
    { ...getAdditionalErrorData(error), additionalMessage: message }
  );
};

export default reportErrorToNewRelic;
